var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLowerThird = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4961 2.64911C17.6005 2.64928 18.4961 3.54464 18.4961 4.64911V13.3991C18.4961 14.5036 17.6005 15.3989 16.4961 15.3991H2.49609C1.39152 15.3991 0.496094 14.5037 0.496094 13.3991V12.527H8.92578C9.42436 12.527 9.82898 12.1232 9.8291 11.6247C9.8291 11.126 9.42444 10.7214 8.92578 10.7214H0.496094V4.64911C0.496094 3.54454 1.39152 2.64911 2.49609 2.64911H16.4961Z",
    fill: "#BFBBCF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLowerThird);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lower-third.e1baba78f92a5c2b85ae07112ef97daf.svg";